import React, { useEffect } from 'react';
import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export let updatePayoutStatusMachine: any;

export const useSMUpdatePayoutStatus = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  updatePayoutStatusMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(updatePayoutStatusMachine);

  return {
    updatePayoutStatusMachine,
    updatePayoutStatusState: state,
    updatePayoutStatusSend: send,
  };
};
